<template>
  <div class="rating-list">
    <b-modal :active.sync="modal.active" has-modal-card>
      <rating-modal :rate="rate" @submit="onSubmit" />
    </b-modal>
    <div class="rating-average mb-1">
      <star-rating class="mb-1" :increment="0.1" :rating="average" :star-size="25" read-only />
      <b-button @click="modal.active = true" v-if="!hideRateButton">
        Rate
      </b-button>
    </div>
    <div class="rating-item mb-1" v-for="rating in ratings" :key="rating.id">
      <p v-if="rating.notes">{{ rating.notes }}</p>
      <star-rating
        :rating="rating.rating"
        :star-size="15"
        :show-rating="false"
        read-only
      />
      <p v-if="rating.createdBy">- {{ rating.createdBy.fullName }}</p>
    </div>
  </div>
</template>

<script>
import RatingModal from "./RatingModal";
import StarRating from "vue-star-rating";

export default {
  props: {
    ratings: {
      type: Array,
      default: () => []
    },
    rate: {
      type: Function
    },
    hideRateButton: {
      type: Boolean,
      default: false
    }
  },
  components: {
    RatingModal,
    StarRating
  },
  data: () => ({
    modal: {
      active: false
    }
  }),
  computed: {
    average() {
      if (this.ratings.length === 0) return 0;

      const rating = this.ratings.reduce((acc, rating) => {
        acc += parseFloat(rating.rating);
        return acc;
      }, 0);
      return rating / this.ratings.length;
    }
  },
  methods: {
    onSubmit(data) {
      this.$emit("submit", data);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Rating/RatingList.vue